import { noop, schQueryParams } from '@aloft/toolkit-shared';
import { Button, Typography } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/prefer-sound-ui-box, aloft/no-sui-chakra, aloft/prefer-sound-ui-button
import { Box, Menu, MenuButton, MenuItem, MenuList } from '@aloft/toolkit-sui/chakra';

import { useEffect } from 'react';

import { useCraftsmanAddCompModals } from '../hooks/useCraftsmanAddCompModals.tsx';
import { useAppSelector } from '../redux/hooks.ts';
import { GuidedTourTooltip } from './GuidedTour/GuidedTourTooltip.tsx';
import { menuListProps, menuProps } from './MainHeader/consts.ts';

export const CraftsmanAddCompButtons = () => {
  const {
    addCompsModal,
    openAddCompsModal,
    addRecommendedCompsModal,
    openAddRecommendedCompsModal,
  } = useCraftsmanAddCompModals();

  const showRecComps = useAppSelector(
    (state) => state.order.propertyType && ['singleFamilyResidence', 'townhouse'].includes(state.order.propertyType),
  );

  useEffect(() => {
    if (new URL(window.location.href).searchParams.get(schQueryParams.enum.addComps) === 'true') {
      openAddRecommendedCompsModal();
    }
  }, [openAddRecommendedCompsModal]);

  return (
    <>
      {addRecommendedCompsModal}
      {addCompsModal}
      <Menu {...menuProps} placement="bottom-end">
        <MenuButton as={Box} style={{ cursor: 'pointer' }}>
          <GuidedTourTooltip
            text={[
              'Click `Add Comps` to add properties or pick a recommended comp.',
              'If you created your order by uploading an appraisal XML, Toolkit automatically brings in comps from that report.',
            ]}
            tourID="analysisTour"
            tourIndex={0}
            placement="left"
          >
            <Button
              variant="primary"
              size="sm"
              text="Add Comps"
              onClick={noop}
              rightIcon="arrow-down-s"
            />
          </GuidedTourTooltip>
        </MenuButton>
        <MenuList {...menuListProps} minWidth="100px" zIndex={1000}>
          {showRecComps && (
            <MenuItem onClick={openAddRecommendedCompsModal}>
              <Typography>Recommended Comps</Typography>
            </MenuItem>
          )}
          <MenuItem onClick={openAddCompsModal}>
            <Typography>Manually Add Comps</Typography>
          </MenuItem>
        </MenuList>
      </Menu>
    </>
  );
};
